import { batchLabel, batchMultiSiteSheets, batchReportFilename } from '../lib/batchMultiSiteReport';
import { exportMultiSheetXLSX } from '../utils/exportUtils';
import type { ApiResponse } from '../types/billValidationTypes';
import { bulkReportService } from './bulkReportService';
import { loadBillReporter } from './billReportLoader';

/**
 * Downloads a report batch's MultiSite Bill Validation Detail Report: its
 * bills, judged with charge maps as Bill Runs judges them. Returns the number
 * of bill rows written.
 */
export async function exportBatchMultiSite(
  batch: { id: string; createdAt: string },
  tolerancePct?: number,
): Promise<ApiResponse<number>> {
  const res = await bulkReportService.batchBills(batch.id);
  if (!res.success || !res.data) return { success: false, error: res.error ?? 'Could not load the bills in this batch' };
  const { billIds, bills } = res.data;
  try {
    const reportFor = await loadBillReporter(bills, tolerancePct);
    const sheets = batchMultiSiteSheets(batchLabel(batch.createdAt), billIds, bills, reportFor);
    exportMultiSheetXLSX(sheets, batchReportFilename(batch.createdAt));
    return { success: true, data: sheets[1].rows.length };
  } catch (error: unknown) {
    return { success: false, error: error instanceof Error ? error.message : 'Could not build the export' };
  }
}
